import { render, staticRenderFns } from "./contact_form.vue?vue&type=template&id=b4973546&"
import script from "./contact_form.vue?vue&type=script&lang=js&"
export * from "./contact_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports